import { IEvent, IServiceItem } from 'shared-types/index';
import PouchLoadService from 'external-services/pouch-load-service/index';
import DateUtilsService from 'external-services/date-utils-service';
import {
  ILoginActions,
  IVenueActions,
  IPouchActions,
  VenueActionNames,
  PouchDocType,
} from 'shared-types/ActionsTypes';

const NS = 'EventsLookupService';

const INVALID_DATE = 'Invalid date';
class EventsLookupService {
  private eventsCache: any = null;
  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  public init(
    PouchActions: IPouchActions,
    LoginActions: ILoginActions,
    VenueActions: IVenueActions
  ): void {
    PouchActions.handlePouchSyncedDoctype(PouchDocType.event, () => this.clearCache());
    // this.$rootScope.$on('logout', () => this.clearCache());
    LoginActions.handleLogout(() => this.clearCache());
    // this.$rootScope.$on('venue-change', () => this.clearCache());
    VenueActions.handleVenueAction(VenueActionNames.VENUE_CHANGE, () => this.clearCache());
  }

  public clearCache(): void {
    this.eventsCache = null;
  }

  public async getAll(): Promise<IEvent[]> {
    if (this.eventsCache) {
      return this.eventsCache;
    }
    const events = await PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'event_',
      endkey: 'event_\uffff',
    });
    this.eventsCache = events.rows.map((item: any) => this.convertEventTimesAndDates(item.doc));
    return this.eventsCache;
  }

  public async getById(id: string): Promise<IEvent> {
    const eventObj: IEvent = await PouchLoadService.getDbLocal().get(id);
    // covert time strings back to dates
    return this.convertEventTimesAndDates(eventObj);
  }
  public isPrivateFunEvent(service: IServiceItem): boolean {
    return service && service.type === 'event' && service.eventType === 'PrivateFunction';
  }

  private convertEventTimesAndDates(eventObj: IEvent): IEvent {

    if (eventObj.date && typeof eventObj.date === 'string' && !eventObj.date.includes('/')) {
      const date = DateUtilsService.dateStrToDateTime(eventObj.date);
      eventObj.date = DateUtilsService.dateToDateTimeStr(date);
    }
    if (eventObj.startDateTime && typeof eventObj.startDateTime === 'string' && !eventObj.startDateTime.includes('/')) {
      const date = DateUtilsService.dateStrToDateTime(eventObj.startDateTime);
      eventObj.startDateTime = DateUtilsService.dateToDateTimeStr(date);
    }
    if (eventObj.endDateTime && typeof eventObj.endDateTime === 'string' && !eventObj.endDateTime.includes('/')) {
      const date = DateUtilsService.dateStrToDateTime(eventObj.endDateTime);
      eventObj.endDateTime = DateUtilsService.dateToDateTimeStr(date);
    }

    if (
      !eventObj.lastBookingTime ||
      (eventObj.lastBookingTime as unknown as string) === INVALID_DATE
    ) {
      // eventObj.lastBookingTime was returning as "Invalid Date" from the couch - hence next line wasnt getting executed and throwing null pointer exception
      eventObj.lastBookingTime = eventObj.endTime;
    }
    eventObj.date = DateUtilsService.dateTimeStrToDate(eventObj.date.toString());
    eventObj.startTime = DateUtilsService.timeToDate(eventObj.startTime, eventObj.date);
    eventObj.firstBookingTime = DateUtilsService.timeToDate(
      eventObj.firstBookingTime,
      eventObj.date
    );

    eventObj.lastBookingTime = DateUtilsService.timeToDate(eventObj.lastBookingTime, eventObj.date);
    eventObj.endTime = DateUtilsService.timeToDate(eventObj.endTime, eventObj.date);
    if (eventObj.endTime?.getTime() < eventObj.lastBookingTime?.getTime()) {
      eventObj.endTime.setDate(eventObj.endTime.getDate() + 1);
    }
    if (eventObj.lastBookingTime?.getTime() < eventObj.firstBookingTime?.getTime()) {
      eventObj.lastBookingTime.setDate(eventObj.lastBookingTime.getDate() + 1);
    }
    if (eventObj.firstBookingTime?.getTime() < eventObj.startTime?.getTime()) {
      eventObj.firstBookingTime.setDate(eventObj.firstBookingTime.getDate() + 1);
    }
    return eventObj;
  }

  public async getEventsOnDate(date: Date): Promise<IEvent[]> {
    const events: IEvent[] = await this.getAll();
    const eventsOnDate: IEvent[] = [];
    events.forEach((eventObj) => {
      if (DateUtilsService.isOnSameDate(eventObj.date as Date, date)) {
        // the blackout occuers on this date
        eventsOnDate.push(eventObj);
      }
    });
    return eventsOnDate;
  }
}

const instance = new EventsLookupService();
export default instance as EventsLookupService;
